<script lang="ts">
	import { Facebook, Instagram, Logo, Tripadvisor } from '$lib/components';
	import CookieConsent from '$lib/components/analytics/CookieConsent.svelte';
	import { AtSign } from 'lucide-svelte';

	type Props = {
		appName: string;
		appUrl: string;
		appPhone: string;
		appEmail: string;
		facebook: string | undefined;
		instagram: string | undefined;
		tripadvisor: string | undefined;
	};

	let { appName, appPhone, appEmail, facebook, instagram, tripadvisor }: Props = $props();

	let emailLinkEl = $state<HTMLAnchorElement>();
	let phoneLinkEl = $state<HTMLAnchorElement>();
	let showCookieConsent = $state(false);

	$effect(() => {
		if (!emailLinkEl) return;
		emailLinkEl.href = 'mailto:' + appEmail;
	});

	$effect(() => {
		if (!phoneLinkEl) return;
		phoneLinkEl.href = 'tel:' + appPhone.replace(/\s/g, '');
	});
</script>

<footer class="print:hidden">
	<div
		class="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-10 pt-8 pb-10 lg:pb-18 bg-two w-full rounded-base"
	>
		<div class="flex px-10 lg:justify-center">
			<div class="flex flex-col gap-y-3">
				<a
					href="/"
					title="Shuttle Shared Service and Private Taxi"
					class="flex items-center gap-x-2 mb-3"
				>
					<Logo />
					<p class="text-2xl font-bold uppercase">{appName}</p>
				</a>
				<div>
					<p class="text-sm text-slate-600 dark:text-slate-300">Phone:</p>
					<p>
						<a bind:this={phoneLinkEl} href="/">{appPhone}</a>
					</p>
				</div>
				<div>
					<p class="text-sm text-slate-600 dark:text-slate-300">Email:</p>
					<p>
						<a bind:this={emailLinkEl} href="/" class="flex items-center gap-x-0.5">
							<span>{appEmail.split('@')[0]}</span>
							<AtSign size={16} />
							<span>{appEmail.split('@')[1]}</span>
						</a>
					</p>
				</div>
			</div>
		</div>
		<div class="flex px-10 lg:justify-center pt-5">
			<div>
				<p class="mb-3 underline text-slate-600 dark:text-slate-400 underline-offset-4">
					Information
				</p>
				<ul class="flex flex-col gap-y-1">
					<li>
						<a href="/questions">Questions?</a>
					</li>
					<li>
						<a href="/terms-and-conditions">Terms & Conditions</a>
					</li>
					<li>
						<a href="/privacy-policy">Privacy Policy</a>
					</li>
					<li>
						<button onclick={() => (showCookieConsent = !showCookieConsent)}>
							Cookie Consent
						</button>
					</li>
				</ul>
			</div>
		</div>
		<div class="flex px-10 lg:justify-center pt-5">
			<div>
				{#if tripadvisor !== '' || facebook !== '' || instagram !== ''}
					<p class="mb-3 underline text-slate-600 dark:text-slate-400 underline-offset-4">
						Follow us
					</p>
					<div class="flex items-center gap-x-3">
						{#if tripadvisor !== ''}
							<a href={tripadvisor} target="_blank">
								<Tripadvisor size={38} />
							</a>
						{/if}
						{#if facebook !== ''}
							<a href={facebook} target="_blank">
								<Facebook size={32} />
							</a>
						{/if}
						{#if instagram !== ''}
							<a href={instagram} target="_blank">
								<Instagram size={32} />
							</a>
						{/if}
					</div>
				{/if}
			</div>
		</div>
	</div>
</footer>
<CookieConsent privacyUrl="/privacy-policy" bind:show={showCookieConsent} />
